import styled from 'styled-components';

import { centeredGridColumns, media } from '@utils/styled';

export const Container = styled.div`
  position: relative;
  grid-column: ${centeredGridColumns(12)};
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 1)};

  ${media.from640up`
    grid-column: ${centeredGridColumns(10)};
  `}

  ${media.from1200up`
    grid-column: ${centeredGridColumns(8)};
  `}
`;
